import { gql } from "@apollo/client";

export default gql`
  mutation SetGovernmentProductStack($products: [ObjectId], $outsideProducts: [OutsideProductInput]) {
    setGovernmentProductStack(productIds: $products, outsideProducts: $outsideProducts) {
      _id
      productsCount
      products {
        _id
        name
        slug
        description
        logo
        isDisruptor
        inViewerStack
        company {
          _id
          name
          slug
        }
      }
      outsideProducts {
        _id
        name
        url
      }
    }
  }
`;
